import { render, staticRenderFns } from "./TermsOfService.vue?vue&type=template&id=2d573a3e&scoped=true&"
var script = {}
import style0 from "./TermsOfService.vue?vue&type=style&index=0&id=2d573a3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d573a3e",
  null
  
)

export default component.exports